module.exports = __webpack_public_path__ + "images/4bbf28551ae0b830a2fd5a1a3372668e1f73f4c3b7616626adc127e6a3e53407.svg";